document.addEventListener("DOMContentLoaded", function () {
  const strings = (window.theme && window.theme.strings) || {};
  var renderVersion = 0;
  var productCache = {};

  function plansForCartItem(item, product, plans) {
    var source = plans || [];
    var variant = (product.variants || []).find(function (entry) {
      return String(entry.id) === String(item.itemID);
    });
    var allocated = {};
    if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
      variant.selling_plan_allocations.forEach(function (allocation) {
        allocated[String(allocation.selling_plan_id)] = true;
      });
    }
    var hasAllocations = Object.keys(allocated).length > 0;
    var seen = {};
    var filtered = [];
    source.forEach(function (plan) {
      if (hasAllocations && !allocated[String(plan.id)]) return;
      var key = String(plan.name || "").toLowerCase().trim();
      var existingIndex = seen[key];
      if (existingIndex === undefined) {
        seen[key] = filtered.length;
        filtered.push(plan);
        return;
      }
      if (String(plan.id) === String(item.itemPlanId)) filtered[existingIndex] = plan;
    });
    return filtered;
  }

  function computePlanData(item, product) {
    var spg = product.selling_plan_groups.filter(function (spg) {
      return spg.app_id == "5859381" && (item.isBundleChild || item.isBundleParent)
        ? spg.name.includes("Bundle")
        : !spg.name.includes("Bundle");
    });

    var sellingPlans = spg.length > 0 ? plansForCartItem(item, product, spg[0].selling_plans) : null;
    var sellingPlanId, planType, toggleButtonClass, subscribeDropdownClass;

    if (item.itemSellingPlanAllocation) {
      sellingPlanId = item.itemPlanId;
      planType = item.itemPlanType;
      toggleButtonClass = "hidden";
      subscribeDropdownClass = "";
    } else if (product.selling_plan_groups.length > 0 && spg.length > 0 && sellingPlans && sellingPlans.length) {
      sellingPlanId = sellingPlans[0].id;
      toggleButtonClass = "";
      subscribeDropdownClass = "hidden";
      planType = "";
    } else {
      toggleButtonClass = "hidden";
      subscribeDropdownClass = "";
      planType = "";
    }

    return {
      sellingPlans: sellingPlans,
      sellingPlanId: sellingPlanId,
      planType: planType,
      toggleButtonClass: toggleButtonClass,
      subscribeDropdownClass: subscribeDropdownClass
    };
  }

  function buildItemHtml(item, index, planData) {
    var productId = item.itemID;
    var productTitle = `<h2>${item.itemTitle}</h2>`;
    var variantTitle = item.itemVariantTitle;
    var productImage = `<img src="${item.itemImage}" >`;
    var productPrice = `<p>$${item.itemPrice}</p>`;
    var productQuantity = item.itemQuantity;
    var productUrl = item.itemUrl;
    var productKey = item.itemKey;
    var productBundleID = item.itemBundleID;
    var bundleChildKeys = item.bundleChildKeys;
    var bundleChildQuantities = item.bundleChildQuantities;
    var bundleItemList = item.bundleItemList;
    var bundleParentKey = item.bundleParentKey;

    var sellingPlans = planData.sellingPlans;
    var sellingPlanId = planData.sellingPlanId;
    var planType = planData.planType;
    var toggleButtonClass = planData.toggleButtonClass;
    var subscribeDropdownClass = planData.subscribeDropdownClass;

    var concatSellingPlanOptions = "";
    if (sellingPlans) {
      sellingPlans.forEach(function (plan) {
        var sellingPlanSelectAttr = plan.id === sellingPlanId ? "selected" : "";
        concatSellingPlanOptions = `
                                        ${concatSellingPlanOptions} 
                                        <option value="${plan.id}" 
                                            product_id="${productId}" 
                                            qty="${productQuantity}" 
                                            key="${productKey}"
                                            plan_id="${sellingPlanId}"
                                            ${sellingPlanSelectAttr}
                                        >
                                            ${plan.name}
                                        </option>
                                    `;
      });
    }

    var concatSubscribeDropdown = `
                                <select name="selling_plan" class="cart_item_selling_plan ${subscribeDropdownClass}" data-subscribe-select>
                                <option value="" 
                                      product_id="${productId}" 
                                      qty="${productQuantity}" 
                                      key="${productKey}"
                                      plan_id="${sellingPlanId}"
                                  >
                                      One-Time Purchase 
                                  </option>   
                                    ${concatSellingPlanOptions}
                                </select>
                            `;

    var qtySelector = `
                              <div class="slidecart-qty-wrapper" >
                                  <button class="qty-button qty-minus-button js-minus-button" data-minus data-qty-button data-key="${productKey}" aria-label="${strings.quantity_decrease || "Decrease Quantity"}">-</button>
                                  <input class="cart-qty-input js-cart-qty-input" type="number" pattern="[0-9]*" data-input-key="${productKey}" value="${productQuantity}" aria-label="${strings.cart_quantity || "Quantity"}"/>
                                  <button class="qty-button qty-plus-button js-plus-button" data-plus data-qty-button data-key="${productKey}" aria-label="${strings.quantity_increase || "Increase Quantity"}">+</button>
                              </div>                                         
                            `;

    var subscribeBtn = `<button class="cart-item-payment-options__button ${toggleButtonClass}"
                                            key="${productKey}" 
                                            qty="${productQuantity}" 
                                            plan_id="${sellingPlanId}"
                                            product_id="${productId}" 
                                            data-cart-toggle-subscribe 
                                        >
                                           <span class="subUpsell"> Subscribe & Save </span>
                                        </button>
                                        <div id="loading-indicator-${productId}" style="display: none;">
                                            <span class="indicator">Procesing...</span>
                                            <em class="loader loader--line"><em class="loader-indeterminate"></em></em>
                                        </div>

                            `;

    return `
                                <div class="slidecart-item-wrapper" 
                                    data-slidecart-item="${productId}" 
                                    data-line="${Number(index + 1)}" 
                                    data-bundle-child-keys="${bundleChildKeys}" 
                                    data-bundle-child-quantities="${bundleChildQuantities}" 
                                    data-bundle-id="${productBundleID}" 
                                    data-bundle-parent-key="${bundleParentKey}" 
                                >
                                    <div class="slidecart-item-image-wrapper">${productImage}</div>
                                    <div class="slidecart-item-details-wrapper">
                                        <div class="slidecart-item-details-top">
                                            <div class="slidecart-item-description-wrapper">
                                                <a class="slidecart-item-title" href="${productUrl}">${productTitle}</a> 
                                                ${
                                                  variantTitle != undefined &&
                                                  variantTitle !=
                                                    "Default Variant"
                                                    ? `<p>${variantTitle}</p>`
                                                    : ``
                                                }
                                                ${bundleItemList}
                                                <span class="slidecart-item-purchase-frequency ${toggleButtonClass}">${planType}</span>
                                                ${concatSubscribeDropdown}
                                            </div>
                                            <span class="slidecart-item-price">${productPrice}</span> 
                                            <div class="slidecart-item-qty-wrapper">
                                                 ${
                                                   productBundleID
                                                     ? ""
                                                     : qtySelector
                                                 }                                                
                                                <span class="removeItem" data-remove-key="${productKey}">Remove</span>
                                            </div>
                                            
                                        </div>
                                      ${subscribeBtn}
                                    </div>
                                </div>`;
  }

  window.lsgRenderCart = function () {
    return renderCart();
  };
  function renderCart() {
    renderVersion++;
    var currentVersion = renderVersion;
    return $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        if (currentVersion !== renderVersion) return;
        clearCartDrawer();
        const obscuredCartData = obscureCartData(cart);

        //Update cart count
        document
          .querySelectorAll(`.data-cart-count-indicator`)
          .forEach((cartCount) => (cartCount.innerHTML = cart.item_count));

        // Update header bag --has-items class (theme.js used to do this via
        // [data-cart-drawer-toggle]; bag now uses [data-slidecart-trigger]).
        document
          .querySelectorAll(".cart__toggle")
          .forEach((toggle) =>
            toggle.classList.toggle("cart__toggle--has-items", cart.item_count > 0)
          );

        updateQuantityElements(obscuredCartData);

        $(`[shipping-bar-percent]`).css("max-width", "0%");
        const freeShipText = $(`[slidecart-shipping-bar]`).attr(
          "free-shipping-text"
        );
        const freeShipping = $(`[slidecart-shipping-bar]`).attr(
          "free-shipping-minimum"
        );
        const cartSubtotal = `<p>$${parseFloat(cart.items_subtotal_price / 100)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
          .toString()}</p>`;
        const cartSubtotalInfo = `<h2>Subtotal</h2> ${cartSubtotal}`;
        $(`[cart-subtotal]`).html(cartSubtotalInfo);
        $(".slidecart-shipping-bar .shipping-notice").each(function () {
          var text = $(this).text();
          if (text.includes("{{ price }}")) {
            text = text.replace("{{ price }}", `$${freeShipping}`);
            $(this).text(text);
          }
        });
        var amountToShipping = (
          parseInt(freeShipping) -
          parseFloat(cart.items_subtotal_price / 100).toFixed(2)
        ).toFixed(2);
        if (amountToShipping <= 0) {
          $(`[shipping-bar-percent]`).css("max-width", "100%");
          $(".slidecart-shipping-bar .shipping-notice").each(function () {
            var text = $(this).attr("shipping-text");
            text = `${freeShipText}`;
            $(this).text(text);
          });
          $(".shipping-info-amount-pre-threshold").addClass("hidden");
          $(".shipping-info-amount-post-threshold").removeClass("hidden");
        } else if (parseInt(amountToShipping) == parseInt(freeShipping)) {
          $("[slidecart-product-wrapper]").html("");
          $(".slidecart-shipping-bar .shipping-notice").each(function () {
            var text = $(this).attr("shipping-text");
            text = "Your cart is empty";
            $(this).text(text);
          });
          $(".shipping-info-amount-pre-threshold").removeClass("hidden");
          $(".shipping-info-amount-post-threshold").addClass("hidden");
        } else {
          $(".slidecart-shipping-bar .shipping-notice").each(function () {
            var text = $(this).attr("shipping-text");
            text = `Spend $${parseInt(
              amountToShipping
            )} more for Free shipping!`;
            $(this).text(text);
          });
          $(`[shipping-label]`).html("");
          var maxWidth =
            (parseFloat(cart.items_subtotal_price / 100).toFixed(1) /
              parseInt(freeShipping)) *
            100;
          $(`[shipping-bar-percent]`).css("max-width", maxWidth + "%");
          $(".shipping-info-amount-pre-threshold").removeClass("hidden");
          $(".shipping-info-amount-post-threshold").addClass("hidden");
        }

        var handlesToFetch = {};

        obscuredCartData.forEach((item, index) => {
          if (item.isBundleChild) return;
          if (!item.itemHandle) return;

          var handle = item.itemHandle;
          var cachedProduct = productCache[handle];
          var planData;

          if (cachedProduct) {
            planData = computePlanData(item, cachedProduct);
          } else {
            planData = {
              sellingPlans: null,
              sellingPlanId: item.itemSellingPlanAllocation ? item.itemPlanId : null,
              planType: item.itemSellingPlanAllocation ? item.itemPlanType : "",
              toggleButtonClass: "hidden",
              subscribeDropdownClass: "hidden"
            };
            if (!handlesToFetch[handle]) handlesToFetch[handle] = [];
            handlesToFetch[handle].push({ item: item, index: index });
          }

          $(`[slidecart-product-wrapper]`).html(
            $(`[slidecart-product-wrapper]`).html() + buildItemHtml(item, index, planData)
          );
        });

        Object.keys(handlesToFetch).forEach(function (handle) {
          jQuery
            .getJSON(window.Shopify.routes.root + `products/${handle}.js`)
            .done(function (product) {
              productCache[handle] = product;
              if (currentVersion !== renderVersion) return;
              handlesToFetch[handle].forEach(function (entry) {
                var planData = computePlanData(entry.item, product);
                var $el = $(`[slidecart-product-wrapper] [data-line="${Number(entry.index + 1)}"]`);
                if ($el.length) $el.replaceWith(buildItemHtml(entry.item, entry.index, planData));
              });
            })
            .fail(function () {});
        });

        // Mark inner wrapper as scroll-lock scrollable so theme allows drawer scrolling
        try { $(".slidecart-inner-wrapper").attr("data-scroll-lock-scrollable", ""); } catch (e) {}
      },
    });
  }
  window.lsgSlideCartOpen = function () {
    slideCartOpen();
  };
  function isDrawerCartEnabled() {
    return !window.theme || !window.theme.settings || window.theme.settings.cartType === "drawer";
  }
  function slideCartOpen() {
    var wrapper = document.getElementById("slidecart-wrapper");
    if (wrapper && wrapper.classList.contains("active")) {
      renderCart();
      return;
    }
    document.body.classList.add("js-drawer-open-cart");
    $(`#slidecart-wrapper`).addClass("active");
    $(`[slidecart-overlay]`).addClass("active");
    document.dispatchEvent(
      new CustomEvent("theme:scroll:lock", { bubbles: true, detail: wrapper })
    );
    renderCart();
  }
  window.lsgSlideCartClose = function () {
    slideCartClose();
  };
  function slideCartClose() {
    document.body.classList.remove("js-drawer-open-cart");
    $(`#slidecart-wrapper`).removeClass("active");
    $(`[slidecart-overlay]`).removeClass("active");
    document.dispatchEvent(
      new CustomEvent("theme:scroll:unlock", { bubbles: true })
    );
  }
  $('[href="/cart"]:not([data-slidecart-trigger])').on("click", function (e) {
    if (!isDrawerCartEnabled()) return;
    e.preventDefault();
    slideCartOpen();
  });
  document.addEventListener("theme:cart:added", function (event) {
    if (!isDrawerCartEnabled()) return;
    slideCartOpen();
  });

  //Slide cart open on product added
  $(".addToCartBtn").on("click", function (e) {
    if (!isDrawerCartEnabled()) return;
    e.preventDefault();
    slideCartOpen();
  });

  $(document).on("click", "[data-slidecart-trigger]", function (e) {
    if (!isDrawerCartEnabled()) return;
    e.preventDefault();
    slideCartOpen();
  });
  $(document).on(
    "click",
    "[data-close-slidecart], [slidecart-overlay]",
    function () {
      slideCartClose();
    }
  );
  renderCart();

  function clearCartDrawer() {
    $(`[slidecart-product-wrapper]`).html("");
  }
  const updateItemSubscription = (event) => {
    let key,
      qty,
      plan,
      oldPlan,
      id,
      additionDataArray = {},
      removalData = {
        updates: {},
      };

    if ($(event.target).is("[data-subscribe-select]")) {
      key = $("option:selected", $(event.target)).attr("key");
      id = parseInt($("option:selected", $(event.target)).attr("product_id"));
      qty = parseInt($("option:selected", $(event.target)).attr("qty"));
      plan = parseInt($("option:selected", $(event.target)).attr("value"));
      oldPlan = parseInt($("option:selected", $(event.target)).attr("plan_id"));
    } else {
      key = $(event.target).closest("[data-cart-toggle-subscribe]").attr("key");
      id = parseInt(
        $(event.target)
          .closest("[data-cart-toggle-subscribe]")
          .attr("product_id")
      );
      qty = parseInt(
        $(event.target).closest("[data-cart-toggle-subscribe]").attr("qty")
      );
      plan = parseInt(
        $(event.target).closest("[data-cart-toggle-subscribe]").attr("plan_id")
      );
    }

    const isOTP = isNaN(parseFloat(plan));

    if (oldPlan === plan) return;

    // Determine if this is a bundle parent
    const bundleChildKeys = $(event.target)
      .closest("[data-bundle-child-keys]")
      .attr("data-bundle-child-keys");
    const bundleChildQuantities = $(event.target)
      .closest("[data-bundle-child-quantities]")
      .attr("data-bundle-child-quantities");
    const bundleID = $(event.target)
      .closest("[data-bundle-id]")
      .attr("data-bundle-id");
    const bundleParentKey = $(event.target)
      .closest("[data-bundle-parent-key]")
      .attr("data-bundle-parent-key");

    const isBundleParent = bundleChildKeys !== "" ? true : false;

    // if this is a bundle parent product
    if (isBundleParent === true) {
      const childKeysArray = bundleChildKeys.split(",");
      const childQuantitiesArray = bundleChildQuantities.split(",");

      let product_data = childKeysArray.map((childKey, i) => {
        const childIsBundleParent = childKey === bundleParentKey ? true : false;
        const currentChildQty = parseInt(childQuantitiesArray[i]);
        const childID = parseInt(childKey.split(":")[0]);

        removalData["updates"][childKey] = 0;

        if (isOTP) {
          return {
            quantity: currentChildQty,
            id: childID,
            properties: {
              _bundle_id: bundleID,
              _bundle_parent: childIsBundleParent,
            },
          };
        } else {
          return {
            quantity: currentChildQty,
            id: childID,
            selling_plan: plan,
            properties: {
              _bundle_id: bundleID,
              _bundle_parent: childIsBundleParent,
            },
          };
        }
      });

      additionDataArray = {
        items: product_data,
      };
    } else {
      removalData["updates"][key] = 0;

      if (isOTP) {
        additionDataArray = {
          items: [
            {
              quantity: qty,
              id: id,
              properties: {
                _bundle_id: false,
                _bundle_parent: false,
              },
            },
          ],
        };
      } else {
        additionDataArray = {
          items: [
            {
              quantity: qty,
              id: id,
              selling_plan: plan,
              properties: {
                _bundle_id: false,
                _bundle_parent: false,
              },
            },
          ],
        };
      }
    }

    const showLoadingIndicator = () => {
      $(`#loading-indicator-${id}`).css("display", "block");
    };

    const hideLoadingIndicator = () => {
      $(`#loading-indicator-${id}`).css("display", "none");
    };

    var reAddAttempts = 0;
    const reAddToCart = () => {
      if (++reAddAttempts > 3) {
        hideLoadingIndicator();
        renderCart();
        return;
      }
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(additionDataArray),
      })
        .then((response) => {
          if (isBundleParent === true) {
            renderCart();
          } else {
            $.ajax({
              type: "GET",
              url: "/cart.js",
              dataType: "json",
              success: (cart) => {
                let productExists = false;
                cart.items.forEach((item) => {
                  const itemBundleID =
                    item.properties !== null
                      ? item.properties.__bundle_id !== undefined
                        ? item.properties.__bundle_id
                        : false
                      : false;
                  if (itemBundleID == false && item.id === id) {
                    productExists = true;
                  }
                });

                if (productExists === false) {
                  reAddToCart();
                } else {
                  renderCart();
                }
              },
            });
          }
        })
        .catch(() => {
          hideLoadingIndicator();
          renderCart();
        })
        .finally(() => {
          hideLoadingIndicator();
        });
    };

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: removalData,
      dataType: "json",
      success: () => {
        showLoadingIndicator();
        setTimeout(function () {
          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: (cart) => {
              var existingItem = null;
              cart.items.forEach((cartItem) => {
                if (cartItem.id === id && !existingItem) {
                  var cartItemPlan = cartItem.selling_plan_allocation
                    ? cartItem.selling_plan_allocation.selling_plan.id
                    : null;
                  if (isOTP && !cartItemPlan) {
                    existingItem = cartItem;
                  } else if (!isOTP && cartItemPlan === plan) {
                    existingItem = cartItem;
                  }
                }
              });

              if (existingItem) {
                $.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  data: {
                    id: existingItem.key,
                    quantity: existingItem.quantity + qty,
                  },
                  dataType: "json",
                  success: () => {
                    hideLoadingIndicator();
                    renderCart();
                  },
                  error: () => {
                    hideLoadingIndicator();
                    renderCart();
                  },
                });
              } else {
                reAddToCart();
              }
            },
            error: () => {
              reAddToCart();
            },
          });
        }, 750);
      },
    });
  };
  const bindSlideCartUIActions = () => {
    function updateItemQuantity(target, key, newQty, currentQty = 1) {
      const productId = $(target).closest("[data-slidecart-item]").attr("data-slidecart-item");
      if (productId) $(`#loading-indicator-${productId}`).css("display", "block");

      const bundleChildKeys = $(target)
        .closest("[data-bundle-child-keys]")
        .attr("data-bundle-child-keys");
      const bundleChildQuantities = $(target)
        .closest("[data-bundle-child-keys]")
        .attr("data-bundle-child-quantities");
      const isBundleParent = bundleChildKeys !== "" ? true : false;

      // if this is a bundle parent product
      if (isBundleParent) {
        const childKeysArray = bundleChildKeys.split(",");
        const childQuantitiesArray = bundleChildQuantities.split(",");

        let formData = {
          updates: {},
        };

        childKeysArray.forEach((childKey, i) => {
          const currentChildQty = parseInt(childQuantitiesArray[i]);
          let newChildQty = (currentChildQty / currentQty) * newQty;
          if (newChildQty < 0) newChildQty = 0;

          formData["updates"][String(childKey)] = newChildQty;
        });

        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: formData,
          dataType: "json",
          success: function () {
            renderCart();
          },
        });
      } else {
        const data = {
          id: key,
          quantity: newQty,
        };

        $(`[data-input-key="${key}"]`).attr("value", newQty);

        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: data,
          dataType: "json",
          success: function () {
            renderCart();
          },
        });
      }
    }

    // Update item quantity
    $(document).on("click", `[data-qty-button]`, (event) => {
      event.preventDefault();

      const key = $(event.target).attr("data-key");
      const currentQty = parseInt($(`[data-input-key="${key}"]`).attr("value"));
      let newQty;

      if ($(event.target).hasClass("js-plus-button")) {
        newQty = currentQty + 1;
      } else {
        newQty = currentQty - 1;
        if (newQty < 0) newQty = 0;
      }

      updateItemQuantity(event.target, key, newQty, currentQty);
    });

    // Remove item
    $(document).on("click", `.slidecart-wrapper span.removeItem`, function (e) {
      var key = $(this).attr("data-remove-key");
      updateItemQuantity(e.target, key, 0);
    });

    // Add upsell
    $(document).on("click", "[data-upsell-atc]", (event) => {
      var variantId = $(event.target).attr("data-upsell-atc");
      var data = {
        id: variantId,
        quantity: 1,
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: () => {
          renderCart();
        },
      });
    });

    // Toggle OTP to Subscribe
    $(document).on("click", "[data-cart-toggle-subscribe]", (event) => {
      event.preventDefault();
      updateItemSubscription(event);
    });

    // Change Subscription Plan
    $(document).on("change", "[data-subscribe-select]", (event) => {
      event.preventDefault();
      updateItemSubscription(event);
    });
  };
  bindSlideCartUIActions();
  const obscureCartData = (cart) => {
    let obscuredCartData = [];

    cart.items.forEach((item) => {
      const itemPrice = parseFloat(item.line_price / 100)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
        .toString();
      const itemSellingPlanAllocation =
        item.selling_plan_allocation !== undefined ? true : false;
      const itemPlanId =
        item.selling_plan_allocation !== undefined
          ? item.selling_plan_allocation.selling_plan.id
          : false;
      const itemPlanType =
        item.selling_plan_allocation !== undefined
          ? item.selling_plan_allocation.selling_plan.name
          : false;
      const itemBundleID =
        item.properties !== null
          ? item.properties._bundle_id !== undefined
            ? item.properties._bundle_id
            : false
          : false;
      const isBundleChild =
        item.properties !== null
          ? item.properties._bundle_id !== undefined &&
            item.properties._bundle_parent === undefined
            ? true
            : false
          : false;
      const isBundleParent =
        item.properties !== null
          ? item.properties._bundle_parent === true
            ? true
            : false
          : false;

      let cartDataItem = {
        itemID: item.id,
        itemTitle: item.title.split(" - ")[0],
        itemVariantTitle: item.title.split(" - ")[1],
        itemHandle: item.handle,
        itemImage: item.image,
        itemPrice: itemPrice,
        itemQuantity: item.quantity,
        itemGrams: item.grams,
        itemUrl: item.url,
        itemKey: item.key,
        itemSellingPlanAllocation: itemSellingPlanAllocation,
        itemPlanId: itemPlanId,
        itemPlanType: itemPlanType,
        itemBundleID: itemBundleID,
        isBundleChild: isBundleChild,
        isBundleParent: isBundleParent,
        bundleChildKeys: "",
        bundleChildQuantities: "",
        bundleItemList: "",
        bundleParentKey: "",
        itemTags: [],
      };

      obscuredCartData.push(cartDataItem);
    });

    let removalIndexes = [];
    obscuredCartData.forEach((mainItem) => {
      if (mainItem.isBundleParent) {
        const mainItemBundleID = mainItem.itemBundleID;

        if (mainItemBundleID) {
          let bundleChildKeys = [];
          let bundleChildQuantities = [];
          let bundleItemList = "";

          obscuredCartData.forEach((comparedItem, i) => {
            const comparedItemBundleID = comparedItem.itemBundleID;
            const comparedItemPrice = parseFloat(comparedItem.itemPrice);

            if (
              comparedItem.isBundleParent === false &&
              comparedItemBundleID === mainItemBundleID
            ) {
              bundleChildKeys.push(comparedItem.itemKey);
              bundleChildQuantities.push(comparedItem.itemQuantity);
              bundleItemList +=
                '<li class="cart-item-bundle-el">' +
                comparedItem.itemTitle +
                " - " +
                comparedItem.itemVariantTitle +
                (comparedItem.itemQuantity > 1
                  ? " (" + comparedItem.itemQuantity + ")"
                  : "") +
                "</li>";
              mainItem.itemPrice = parseFloat(
                parseFloat(mainItem.itemPrice) + comparedItemPrice
              ).toFixed(2);
              removalIndexes.push(i);
            }
            if (
              comparedItem.isBundleParent === true &&
              comparedItemBundleID === mainItemBundleID
            ) {
              bundleChildKeys.push(comparedItem.itemKey);
              bundleChildQuantities.push(comparedItem.itemQuantity);
              mainItem.bundleParentKey = comparedItem.itemKey;
            }
          });

          mainItem.bundleChildKeys = bundleChildKeys;
          mainItem.bundleChildQuantities = bundleChildQuantities;
          mainItem.bundleItemList =
            bundleItemList != ""
              ? '<ul class="cart-item-bundle-items">' + bundleItemList + "</ul>"
              : "";
        }
      }
    });

    obscuredCartData = obscuredCartData.filter((item, index) => {
      return removalIndexes.indexOf(index) == -1;
    });

    return obscuredCartData;
  };
  const initQuantityElements = () => {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        const obscuredCartData = obscureCartData(cart);
        let cartQty = 0;
        obscuredCartData.forEach((item, index) => {
          if (item.isBundleChild) return;
          cartQty = cartQty + item.itemQuantity;
        });
        $("[data-cart-slider-total-quantity]").html(`(${cartQty})`);
        $("[data-lsg-cart-count]").html(cartQty);
      },
    });
  };
  const updateQuantityElements = (data) => {
    const obscuredCartData = data;
    let cartQty = 0;
    obscuredCartData.forEach((item, index) => {
      if (item.isBundleChild) return;
      cartQty = cartQty + item.itemQuantity;
    });
    $("[data-cart-slider-total-quantity]").html(`(${cartQty})`);
    $("[data-lsg-cart-count]").html(cartQty);
  };
});
